import { render, staticRenderFns } from "./SelectTemplateBanner.vue?vue&type=template&id=f2b7422e"
import script from "./SelectTemplateBanner.vue?vue&type=script&lang=js"
export * from "./SelectTemplateBanner.vue?vue&type=script&lang=js"
import style0 from "./SelectTemplateBanner.vue?vue&type=style&index=0&id=f2b7422e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b7422e')) {
      api.createRecord('f2b7422e', component.options)
    } else {
      api.reload('f2b7422e', component.options)
    }
    module.hot.accept("./SelectTemplateBanner.vue?vue&type=template&id=f2b7422e", function () {
      api.rerender('f2b7422e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/atoms/SelectTemplateBanner.vue"
export default component.exports